import React from 'react'; 
import  '../styles/Login.css';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authconfig";
import LoginLogo from '../Images/test.jpeg'

import { McButton } from "@maersk-global/mds-react-wrapper/mc-button";
import { McIcon } from "@maersk-global/mds-react-wrapper/mc-icon"

 const Login = () => {
    const { instance } = useMsal();
    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {});
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {});
        }
    }

 
    return (
    <div className="login-wrapper">  
    <img src={LoginLogo} style={{position:'absolute',top:'3%',left:'2%',height:'17vh'}}></img> 
      <div className="cardlogin">
         <div className='hdr'>Welcome to IONIS Customer Onboarding Platform</div>
        <McButton appearance="primary" label="Sign In with Microsoft" onClick={() => handleLogin("redirect")}><span slot="icon"><McIcon icon="user-circle" color="rgba(255, 255, 255, 1)"></McIcon></span></McButton>
      </div>
    </div>  
    ); 
 }
export default Login;